import { render, staticRenderFns } from "./walkup.vue?vue&type=template&id=231d2b98&scoped=true"
import script from "./walkup.vue?vue&type=script&lang=js"
export * from "./walkup.vue?vue&type=script&lang=js"
import style0 from "./walkup.vue?vue&type=style&index=0&id=231d2b98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231d2b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231d2b98')) {
      api.createRecord('231d2b98', component.options)
    } else {
      api.reload('231d2b98', component.options)
    }
    module.hot.accept("./walkup.vue?vue&type=template&id=231d2b98&scoped=true", function () {
      api.rerender('231d2b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/walkup.vue"
export default component.exports